<template>
  <!-- 患者ダッシュボードメイン画面 -->
  <div id="PDashboardMain">
    <div id="container" style="width: 95vw; min-width: 1250px;">
      <div class="labelTitle lable">{{serviceName}}<span class="labelTitle-area">{{orgName}}</span></div>
      <!--検索条件 -->
      <div class="condition-area">
        <div class="header-button-aria">
          <b-button class="header-button" v-if="isInternalUser" icon-left="chevron-double-left" @click="$router.go(-1)">戻る</b-button>          
          <b-button class="header-button" icon-left="file-download" :disabled="roleId == role.role_salesOffice || isErrorOccerred" @click="excelOutputModalActive = true">帳票出力</b-button>
          <b-button class="header-button" icon-left="account" :disabled="isErrorOccerred" @click="patientManagementModalActive = true">患者管理</b-button>
          <b-button class="header-button" icon-left="cog" :disabled="isErrorOccerred" @click="systemSettingModalActive = true">環境設定</b-button>
          <b-button class="header-button co-button" icon-left="cloud-outline" :disabled="isErrorOccerred" @click="goCo">ケア<br>オーケストレーター</b-button>
          <b-button class="header-button" icon-left="home" @click="goHome">ホーム</b-button>
        </div>
        <div class="condition-input-aria">
          <fieldset :disabled="isErrorOccerred">
            <div>対象期間</div>
            <select v-model="searchConditions.termKind" style="width: 150px;">
              <option v-for="termKind in termKindList" :key="termKind.value" :value="termKind.value">
                {{termKind.label1}}
              </option>
            </select>
            <template v-if="searchConditions.termKind == termKind.term">
              <input class="condition-date-input" type="date" v-model="searchConditions.termStart" :min=minDate :max=maxDate />
              <span>～</span>
            </template>
            <template v-if="searchConditions.termKind == termKind.lastOutputDate || searchConditions.termKind == termKind.term">
              <input class="condition-date-input" type="date" v-model="searchConditions.termEnd" :min=minDate :max=maxDate />
            </template>
            <template v-if="searchConditions.termKind == termKind.latest">
              <select v-model="searchConditions.latestKind" style="width: 180px;">
                <option v-for="latestKind in latestKindList" :key="latestKind.value" :value="latestKind.value">
                  {{latestKind.label1}}
                </option>
              </select>
              <select v-model.number="searchConditions.latestDays" style="width: 80px;">
                <option v-for="latestDays in latestDaysList" :key="latestDays.value" :value="latestDays.value">
                  {{latestDays.label1}}
                </option>
              </select>
            </template>
            <div class="searchButton-area">
              <b-button class="display-button" type="is-primary" @click="doSearch">表示</b-button>
            </div>
          </fieldset>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="isShowPDashboardMainDetail && !isErrorOccerred">
        <div class="result-sub-area">
          <div>
            <span class="result-count-title">該当件数</span>
            <span class="result-count">{{resultListOriginal.length}}件</span>
            <span class="result-count-title">選択件数</span>
            <span class="result-count">{{checkedRows.length}}件</span>
            <div class="template-area">
              <span>表示テンプレート</span>
              <select class="template-select" @change="selectDisplayTemplate" v-model.number="displayTemplateId">
                <option v-for="displayTemplate in displayTemplateList" :key="displayTemplate.id" :value="displayTemplate.id">
                  {{displayTemplate.templateName}}
                </option>
              </select>
              <b-button class="save-button" type="is-primary" @click="displayTemplateRegisterModalActive = true">保存</b-button>
              <span>転記テンプレート</span>
              <select class="template-select" v-model.number="textTemplateId">
                <option v-for="textTemplate in textTemplateList" :key="textTemplate.id" :value="textTemplate.id">
                  {{textTemplate.templateName}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div style="border: solid 1px darkgray;">
          <div class="operation-area">
            <b-tooltip class="operation-aria-tooltip" label="すべて選択">
              <b-button class="operation-aria-button" @click="checkedRows = resultList">
                <img class="button-img" src="@/assets/images/pdashboard/checkbox-all-on.png">
              </b-button>
            </b-tooltip>
            <b-tooltip class="operation-aria-tooltip" label="すべて解除">
              <b-button class="operation-aria-button" @click="checkedRows = []">
                <img class="button-img" src="@/assets/images/pdashboard/checkbox-all-off.png">
              </b-button>
            </b-tooltip>
            <b-tooltip class="operation-aria-tooltip" label="フィルタ解除">
              <b-button class="operation-aria-button" @click="clearFilter()">
                <img class="button-img" src="@/assets/images/pdashboard/filter-all-off.png">
              </b-button>
            </b-tooltip>
            <b-tooltip class="operation-aria-tooltip" label="ファイル出力">
              <b-button class="operation-aria-button" :disabled="checkedRows.length == 0" @click="fileOutputSettingModalActive = true">
                <img class="button-img" src="@/assets/images/pdashboard/output-setting-icon.png">
              </b-button>
            </b-tooltip>
            <b-tooltip class="operation-aria-tooltip" label="テキスト転記">
              <b-button class="operation-aria-button" :disabled="checkedRows.length == 0" @click="showTextTranscription()">
                <img class="button-img" src="@/assets/images/pdashboard/transcribing-text-icon.png">
              </b-button>
            </b-tooltip>
          </div>
          <div class="result-table-area">
            <label class="anchor-filter" id="anchorFilter"></label>
            <table class="pdashboard-filter-table" id="pDashboardMainFilterTable">
              <tr style="display: inline-flex;">
                <td class="filter-first-td"></td>
                <td v-for="setting in displayTemplate.settingList" :key="setting.itemId">
                  <input v-if="setting.displayFlag && !isTimeType(setting.dataType)"
                    name="filterValue1"
                    :class="['filter-value-input', setting.filterValue1 ? 'filtered-input' : '']"
                    :type="isNumericType(setting.dataType) ? 'number' : 'text'"
                    step="any"
                    v-model="setting.filterValue1"
                    :placeholder="setting.itemName"
                    :style="'width: ' + (setting.width - 20) + 'px;'"
                    @input="inputFilterValue()"/>
                  <vue-timepicker v-if="setting.displayFlag && isTimeType(setting.dataType)"
                    name="filterValue1"
                    format="H時間m分"
                    hour-label="時間"
                    minute-label="分"
                    v-model="setting.filterValue1"
                    :key="setting.filterValue1 ? JSON.stringify(setting.filterValue1) : 'blank'"
                    :placeholder="setting.itemName"
                    lazy
                    auto-scroll
                    manual-input
                    close-on-complete
                    :style="'width: ' + (setting.width - 20) + 'px'"
                    @focus="setAnchor()"
                    @input="inputFilterValue()"
                    :class="setting.filterValue1 && (setting.filterValue1.H || setting.filterValue1.m) ? 'filtered-input' : ''"/>
                  <b-dropdown id="pDashboardMainFilterCondition" v-model="setting.filterCondition1" aria-role="list" :mobile-modal="false">
                    <template #trigger>
                      <button v-if="setting.displayFlag" class="mdi mdi-filter filter-condition-button" @click="setAnchor()"></button>
                    </template>
                    <template v-if="isStringType(setting.dataType)">
                      <b-dropdown-item v-for="filterCondition in stringFilterConditionList" :key="filterCondition.value"
                        :value="filterCondition.value"
                        aria-role="listitem"
                        style="padding: 2px 5px;"
                        @click="filterResultTableAll()">
                        {{filterCondition.label1}}
                      </b-dropdown-item>
                    </template>
                    <template v-else>
                      <b-dropdown-item v-for="filterCondition in numberFilterConditionList" :key="filterCondition.value"
                        :value="filterCondition.value"
                        aria-role="listitem"
                        style="padding: 2px 5px;"
                        @click="filterResultTableAll()">
                        {{filterCondition.label1}}
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </td>
              </tr>
              <tr style="display: inline-flex;">
                <td class="filter-first-td"></td>
                <td v-for="setting in displayTemplate.settingList" :key="setting.itemId">
                  <input v-if="setting.displayFlag && !isTimeType(setting.dataType)"
                    name="filterValue2"
                    :class="['filter-value-input', setting.filterValue2 ? 'filtered-input' : '']"
                    :type="isNumericType(setting.dataType) ? 'number' : 'text'"
                    step="any"
                    v-model="setting.filterValue2"
                    :placeholder="setting.itemName"
                    :style="'width: ' + (setting.width - 20) + 'px'"
                    @input="inputFilterValue()"/>
                  <vue-timepicker v-if="setting.displayFlag && isTimeType(setting.dataType)"
                    name="filterValue2"
                    format="H時間m分"
                    hour-label="時間"
                    minute-label="分"
                    v-model="setting.filterValue2"
                    :key="setting.filterValue2 ? JSON.stringify(setting.filterValue2) : 'blank'"
                    :placeholder="setting.itemName"
                    lazy
                    auto-scroll
                    manual-input
                    close-on-complete
                    :style="'width: ' + (setting.width - 20) + 'px'"
                    @focus="setAnchor()"
                    @input="inputFilterValue()"
                    :class="setting.filterValue2 && (setting.filterValue2.H || setting.filterValue2.m) ? 'filtered-input' : ''"/>
                  <b-dropdown id="pDashboardMainFilterCondition" v-model="setting.filterCondition2" aria-role="list" :mobile-modal="false">
                    <template #trigger>
                      <button v-if="setting.displayFlag" class="mdi mdi-filter filter-condition-button" @click="setAnchor()"></button>
                    </template>
                    <template v-if="isStringType(setting.dataType)">
                      <b-dropdown-item v-for="filterCondition in stringFilterConditionList" :key="filterCondition.value"
                        :value="filterCondition.value"
                        aria-role="listitem"
                        style="padding: 2px 5px;"
                        @click="filterResultTableAll()">
                        {{filterCondition.label1}}
                      </b-dropdown-item>
                    </template>
                    <template v-else>
                      <b-dropdown-item v-for="filterCondition in numberFilterConditionList" :key="filterCondition.value"
                        :value="filterCondition.value"
                        aria-role="listitem"
                        style="padding: 2px 5px;"
                        @click="filterResultTableAll()">
                        {{filterCondition.label1}}
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </td>
              </tr>
            </table>
            <b-table
              class="pdashboard-result-table"
              id="pDashboardMainResultTable"
              ref="pDashboardMainResultTable"
              :data="resultList"
              :columns="columns"
              checkable
              :checked-rows.sync="checkedRows"
              :default-sort="defaultSortField"
              :default-sort-direction="defaultSortDirection"
              :row-class="(row) => !row.useDays && 'unuse'"
              :mobile-cards="false"
              paginated
              per-page="50"
              narrowed
              backend-sorting
              @page-change="changePage()"
              @sort="sortResultTable">
              <template slot-scope="props">
                <b-table-column v-for="setting in displayTemplate.settingList" :key="setting.itemId"
                  :name="'resultValue-' + setting.itemId"
                  :visible="setting.itemName && setting.displayFlag"
                  :numeric="isNumericType(setting.dataType)"
                  sortable>
                  <a v-if="setting.itemId == 'patientExternalId'"
                    target="_blank"
                    :href="'https://' + hostName + '/#/patient/' + props.row.patientId + '/therapydata'">
                    {{ props.row[setting.itemId] ? props.row[setting.itemId] : "&nbsp;ー&nbsp;" }}
                  </a>
                  <span v-else-if="isNumericType(setting.dataType)">{{ props.row[setting.itemId] }}</span>
                  <span v-else>{{ props.row[setting.itemId] }}</span>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 帳票出力確認モーダル -->
    <b-modal :active.sync="excelOutputModalActive" has-modal-card @close="excelOutputModalActive = false">
      <PDashboardExcelDownload/>
    </b-modal>
    <!-- 患者管理モーダル画面-->
    <b-modal :active.sync="patientManagementModalActive" has-modal-card @close="closeModal">
      <PDashboardPatientManagementModal/>
    </b-modal>
    <!-- 環境設定モーダル画面 -->
    <b-modal :active.sync="systemSettingModalActive" has-modal-card @close="closeModal">
      <PDashboardSystemSettingModal :displayTemplate="displayTemplate" @backSystemSetting="backSystemSetting"/>
    </b-modal>
    <!-- テキスト転記モーダル画面 -->
    <b-modal :active.sync="transcribingTextModalActive" has-modal-card @close="closeModal">
      <PDashboardTranscribingTextModal :templateId="textTemplateId" :checkedRows="checkedRows" @reDisplayColumns="reDisplayColumns" />
    </b-modal>
    <!-- ファイル出力設定画面 -->
    <b-modal v-if="displayTemplate" :active.sync="fileOutputSettingModalActive" has-modal-card @close="closeModal">
      <PDashboardFileOutputSettingModal :checkedRows="checkedRows" :displayTemplateSettingList="displayTemplate.settingList" />
    </b-modal>
    <!-- 表示テンプレート登録画面 -->
    <b-modal :active.sync="displayTemplateRegisterModalActive" has-modal-card @close="closeModal()">
      <PDashboardDisplayTemplateRegisterModal
        :displayTemplateList="displayTemplateList"
        :displayTemplate="displayTemplate"
        :defaultSortField="defaultSortField"
        :defaultSortDirection="defaultSortDirection"
        @backDisplayTemplateRegister="backDisplayTemplateRegister" />
    </b-modal>
  </div>
</template>

<script>
import {
  choicesType,
  pDashboardServiceName,
  pDashboardTermKind,
  pDashboardFilterCondition,
  role
} from "@/components/mock/base/const.js";
import _ from "lodash";
import VueTimepicker from "vue2-timepicker";
import "@/components/mock/guest/patientdashboard/css/VueTimepickerForPDashboardMain.css";
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";
// 患者管理モーダル画面
import PDashboardPatientManagementModal from "@/components/mock/guest/patientdashboard/PDashboardPatientManagementModal";
// 帳票出力画面
import PDashboardExcelDownload from "@/components/mock/guest/patientdashboard/PDashboardExcelDownload";
// 環境設定画面
import PDashboardSystemSettingModal from "@/components/mock/guest/patientdashboard/PDashboardSystemSettingModal";
// テキスト転記画面
import PDashboardTranscribingTextModal from "@/components/mock/guest/patientdashboard/PDashboardTranscribingTextModal";
// ファイル出力設定画面
import PDashboardFileOutputSettingModal from "@/components/mock/guest/patientdashboard/PDashboardFileOutputSettingModal";
// 表示テンプレート登録画面
import PDashboardDisplayTemplateRegisterModal from "@/components/mock/guest/patientdashboard/PDashboardDisplayTemplateRegisterModal";

export default {
  name: "PDashboardMain",
  data() {
    let userInfo = this.getUserInfo();
    return {
      /** サービス名(定数) */
      serviceName: pDashboardServiceName,
      /** 対象期間の種類(定数) */
      termKind: pDashboardTermKind,
      /** フィルタ条件(定数) */
      filterCondition: pDashboardFilterCondition,
      /** ホスト名 */
      hostName: null,
      /** 内部ユーザかどうか */
      isInternalUser: false,
      /** エラーが発生したかどうか(初期表示後にfalseへ変更) */
      isErrorOccerred: true,
      /** 対象期間(種類)リスト */
      termKindList: [],
      /** 直近(種類)リスト */
      latestKindList: [],
      /** 直近(日数)リスト */
      latestDaysList: [],
      /** フィルタ条件リスト(文字列用) */
      stringFilterConditionList: [],
      /** フィルタ条件リスト(数値・時間用) */
      numberFilterConditionList: [],
      /** 表示テンプレートリスト */
      displayTemplateList: [],
      /** 転記テンプレートリスト */
      textTemplateList: [],
      /** 検索条件 */
      searchConditions: {
        /** 対象期間(種類) */
        termKind: null,
        /** 対象期間(開始日) */
        termStart: null,
        /** 対象期間(終了日) */
        termEnd: null,
        /** 直近(種類) */
        latestKind: null,
        /** 直近(日数) */
        latestDays: null
      },
      /** 選択中の表示テンプレートID */
      displayTemplateId: null,
      /** 選択中の転記テンプレートID */
      textTemplateId: null,
      /** 選択中の表示テンプレート */
      displayTemplate: null,
      /** 明細並び替え項目 */
      defaultSortField: null,
      /** 明細表示順 */
      defaultSortDirection: null,
      /** 検索結果一覧(オリジナル) */
      resultListOriginal: [],
      /** 検索結果一覧 */
      resultList: [],
      /** 検索結果一覧のカラム */
      columns: [],
      /** 選択行のリスト */
      checkedRows: [],
      /** 検索結果一覧表示フラグ */
      isShowPDashboardMainDetail: false,
      /** 患者管理表示フラグ */
      patientManagementModalActive: false,
      /** 帳票出力表示フラグ */
      excelOutputModalActive: false,
      /** 環境設定表示フラグ */
      systemSettingModalActive: false,
      /** 表示テンプレート登録表示フラグ */
      displayTemplateRegisterModalActive: false,
      /** ファイル出力設定表示フラグ */
      fileOutputSettingModalActive: false,
      /** テキスト転記表示フラグ */
      transcribingTextModalActive: false,
      /** 表示項目保持リスト */
      displayItemKeepList: [],
      /** 治療データ取得範囲の最大日 */
      maxDate: null,
      /** 治療データ取得範囲の最小日 */
      minDate: null,
      /** 所属組織名 */
      orgName: null,
      /** 権限 */
      role: role,
      /** 権限ID */
      roleId: userInfo.roleId
    };
  },
  async mounted() {
    this.termKindList = this.getChoiceList(choicesType.pDashboardTermKind, false);
    this.latestKindList = this.getChoiceList(choicesType.pDashboardLatestKind, false);
    this.latestDaysList = this.getChoiceList(choicesType.pDashboardLatestDays, false);
    this.stringFilterConditionList = this.getChoiceList(choicesType.pDashboardStringFilter, false);
    this.numberFilterConditionList = this.getChoiceList(choicesType.pDashboardNumberFilter, false);

    // 内部ユーザかどうかを判定
    this.isInternalUser = this.getUserInfo().belongsId == 0;

    let _this = this;
    await this.apiCall(
      function(client) {
        return client.apis.externalPDashboard.getPDashboardMainSearchConditionPOST({
          body:{}
        });
      },
      function(result) {
        if (result && result.status == 200) {
          // 検索条件
          _this.searchConditions = result.obj.searchConditions;
          // 対象期間(開始日)
          _this.searchConditions.termStart = result.obj.previousDate;
          // 対象期間(終了日)
          _this.searchConditions.termEnd = result.obj.previousDate;
          // 表示テンプレートのリスト
          _this.displayTemplateList = result.obj.displayTemplateList;
          // 表示項目保持リスト
          _this.displayItemKeepList = result.obj.displayTemplateList;
          // 転記テンプレートのリスト
          _this.textTemplateList = result.obj.textTemplateList;
          // ホスト名
          _this.hostName = result.obj.hostName;
          // 治療データ取得範囲の最大日
          _this.maxDate = result.obj.maxDate;
          // 治療データ取得範囲の最小日
          _this.minDate = result.obj.minDate;
          // 所属組織名
          _this.orgName = result.obj.orgName;

          // 既定の表示テンプレートを選択
          let defaultTemplate = _this.displayTemplateList.find(template => template.defaultFlag);
          if (defaultTemplate) {
            _this.displayTemplateId = defaultTemplate.id;
            _this.displayTemplate = defaultTemplate;
          } else {
            // 既定の表示テンプレートがない場合は標準設定を選択
            _this.displayTemplateId = _this.displayTemplateList[0].id;
            _this.displayTemplate = _this.displayTemplateList[0];
          }

          // 既定の転記テンプレートを選択
          defaultTemplate = _this.textTemplateList.find(template => template.defaultFlag);
          _this.textTemplateId = defaultTemplate ? defaultTemplate.id : null;

          // 明細の並び順を変更
          _this.$nextTick(_this.setSortColumn);

          // これ以降は入力可能
          _this.isErrorOccerred = false;
        } else {
          // エラーメッセージを表示
          _this.showErrorMessage(UNEXPECTED_ERROR);
        }
      },
      function(result){
        // エラーメッセージを表示
        _this.showErrorMessage(result);
      }
    );
  },
  methods: {
    doSearch: async function() {
      try {
        let errMsg = "";
        let minDateString = this.minDate.replaceAll("-", "/");
        let maxDateString = this.maxDate.replaceAll("-", "/");

        // 「前回出力日から」の場合
        if (this.searchConditions.termKind == this.termKind.lastOutputDate) {
          // 必須チェック：終了日
          if (!this.searchConditions.termEnd) {
            errMsg = "終了日は必須項目です。";
          } else {
            // 範囲チェック：終了日
            if (this.searchConditions.termEnd < this.minDate) {
              errMsg = "終了日は" + minDateString + "以降の日付を指定してください。";
            } else if (this.searchConditions.termEnd > this.maxDate) {
              errMsg = "終了日は" + maxDateString + "以前の日付を指定してください。";
            }
          }
        }
        // 「期間設定」の場合
        if (this.searchConditions.termKind == this.termKind.term) {
          // 必須チェック：開始日
          if (!this.searchConditions.termStart) {
            errMsg = "開始日は必須項目です。";
          } else {
            // 範囲チェック：開始日
            if (this.searchConditions.termStart < this.minDate) {
              errMsg = "開始日は" + minDateString + "以降の日付を指定してください。";
            } else if (this.searchConditions.termStart > this.maxDate) {
              errMsg = "開始日は" + maxDateString + "以前の日付を指定してください。";
            }
          }
          // 必須チェック：終了日
          if (!this.searchConditions.termEnd) {
            errMsg += errMsg ? "\n" : "";
            errMsg += "終了日は必須項目です。";
          } else {
            // 範囲チェック：終了日
            if (this.searchConditions.termEnd < this.minDate) {
              errMsg += errMsg ? "\n" : "";
              errMsg += "終了日は" + minDateString + "以降の日付を指定してください。";
            } else if (this.searchConditions.termEnd > this.maxDate) {
              errMsg += errMsg ? "\n" : "";
              errMsg += "終了日は" + maxDateString + "以前の日付を指定してください。";
            }
          }
          // 大小チェック：開始日、終了日
          if (!errMsg) {
            if (this.searchConditions.termEnd < this.searchConditions.termStart) {
              errMsg = "日付の大小関係が不正です。";
            }
          }
        }

        // エラーがある場合
        if (errMsg) {
          // エラーメッセージを表示
          this.showErrorMessage(errMsg);
          return;
        }

        let _this = this;
        await this.apiCall(
          function(client) {
            let searchConditions = _this.searchConditions;
            return client.apis.externalPDashboard.getPDashboardTherapyListPOST({
              body:{
                searchConditions: searchConditions
              }
            });
          },
          function(result) {
            if (result && result.status == 200) {
              // 検索結果一覧を設定
              _this.resultListOriginal = result.obj.resultList;
              _this.resultList = result.obj.resultList;
              // 検索結果一覧とフィルタ一覧を更新
              _this.filterResultTableAll();
              // 選択行をクリア
              _this.checkedRows = [];
              // 明細の並び順を変更
              _this.$nextTick(_this.setSortColumn);
              // スクロールの位置をリセット
              _this.resetScrollPosition();
              // 検索結果一覧を表示
              _this.isShowPDashboardMainDetail = true;
            } else {
              _this.isErrorOccerred = true;
              // エラーメッセージを表示
              _this.showErrorMessage(UNEXPECTED_ERROR);
            }
          },
          function(result){
            _this.isErrorOccerred = true;
            // エラーメッセージを表示
            _this.showErrorMessage(result);
          }
        );
      } catch (error) {
        this.isErrorOccerred = true;
        // エラーメッセージを表示
        this.showErrorMessage(UNEXPECTED_ERROR);
      }
    },
    resetScrollPosition: function() {
      // 検索結果一覧が表示されている場合
      if (!this.isShowPDashboardMainDetail) {
        return;
      }

      // 検索結果一覧のテーブルを取得
      let resultTable = document.getElementById("pDashboardMainResultTable");
      let tableWrapper = resultTable.getElementsByClassName("table-wrapper")[0];
      // フィルタのテーブルを取得
      let filterTable = document.getElementById("pDashboardMainFilterTable");

      // スクロールの位置をリセット
      tableWrapper.scrollTop = 0;
      tableWrapper.scrollLeft = 0;
      filterTable.scrollLeft = 0;
    },
    onScroll: function() {
      // 検索結果一覧のテーブルを取得
      let resultTable = document.getElementById("pDashboardMainResultTable");
      let tableWrapper = resultTable.getElementsByClassName("table-wrapper")[0];
      // フィルタのテーブルを取得
      let filterTable = document.getElementById("pDashboardMainFilterTable");

      filterTable.scrollLeft = tableWrapper.scrollLeft;
    },
    selectDisplayTemplate: function() {
      // 設定情報の明細表示順を更新
      let beforeChangeTemplate = this.displayTemplateList.find(displayTemplate => displayTemplate.id == this.displayTemplate.id);
      for (let beforeSetting of beforeChangeTemplate.settingList) {
        beforeSetting.detailDisplayOrder = beforeSetting.itemId == this.defaultSortField ? this.defaultSortDirection : null;
      }

      // 選択中の表示テンプレート
      this.displayTemplate = this.displayTemplateList.find(template => {
        return template.id == this.displayTemplateId;
      });

      // 表示するカラムを変更
      this.setColumns();

      // フィルタを適用
      this.filterResultTableAll();

      // 明細の並び順を変更
      this.$nextTick(this.setSortColumn);

      // スクロールの位置をリセット
      this.resetScrollPosition();
    },
    setColumns: function() {
      let columns = [];
      for (let setting of this.displayTemplate.settingList) {
        columns.push({
          "field": setting.itemId,
          "label": setting.itemName,
          "width": setting.width,
          "visible": setting.itemName && setting.displayFlag,
          "sortable": true
        });
      }

      this.columns = columns;
    },
    changePage: function() {
      // 検索結果一覧のテーブルを取得
      let resultTable = document.getElementById("pDashboardMainResultTable");
      let tableWrapper = resultTable.getElementsByClassName("table-wrapper")[0];

      // 検索結果一覧の縦スクロールの位置をリセット
      tableWrapper.scrollTop = 0;

      // 最後のページを開くとヘッダが消えるため表示するカラムを再設定(b-tableのバグ対応)
      this.$nextTick(this.setColumns);
    },
    setSortColumn: function() {
      // 明細の並び順を変更
      let defaultSortItem = this.displayTemplate.settingList.find(item => item.detailDisplayOrder);
      this.defaultSortField = defaultSortItem.itemId;
      this.defaultSortDirection = defaultSortItem.detailDisplayOrder;

      // 明細の並び順を適用
      if (this.$refs.pDashboardMainResultTable) {
        this.$nextTick(this.$refs.pDashboardMainResultTable.initSort);
      }
    },
    sortResultTable: function(field, direction) {
      // 選択列(明細の並び替え項目)と表示順を保持
      this.defaultSortField = field;
      this.defaultSortDirection = direction;

      // 選択列のデータ型を取得
      let dataType = this.displayTemplate.settingList.find(setting => setting.itemId == field).dataType;
      // 並び順を判定(ascは昇順、descは降順)
      let sign = direction == "asc" ? -1 : 1;

      this.resultList.sort((a, b) => {
        // 選択列に値がない行は後ろに移動
        if (!a[field] && a[field] != 0) {
          // 前側(a)に値がない場合は後ろに移動
          return 1;
        } else if (!b[field] && b[field] != 0) {
          // 前側(a)に値があり後側(b)に値がない場合は前に移動
          return -1;
        }

        let valueA;
        let valueB;
        if (this.isNumericType(dataType)) {
          // データ型が数値の場合は数値に変換
          valueA = Number(a[field]);
          valueB = Number(b[field]);
        } else if (this.isTimeType(dataType) || field == "totalUsageMinutesFormat") {
          // データ型が時間の場合は分に変換(並び替えでは累積使用時間を時間として扱う)
          valueA = this.getMinutesByString(a[field]);
          valueB = this.getMinutesByString(b[field]);
        } else {
          // その他のデータ型の場合はそのまま
          valueA = a[field];
          valueB = b[field];
        }

        // 前側(a)も後側(b)も値がある場合は値を比較して並び替え
        return valueA < valueB ? sign : sign * (-1);
      });

      // 検索結果一覧の設定を調整
      this.$nextTick(this.setResultTableSetting);
    },
    inputFilterValue: _.debounce(function() {
      // 入力イベントを0.5秒間引きしたあと最後に一度だけフィルタを適用
      this.filterResultTableAll();
    }, 500),
    filterResultTableAll: function() {
      let tmpResultList = this.getCopy(this.resultListOriginal);

      for (let setting of this.displayTemplate.settingList) {
        // 上段のフィルタを適用
        tmpResultList = this.filterResultTable(tmpResultList, setting.itemId, setting.dataType, setting.filterCondition1, setting.filterValue1);
        // 下段のフィルタを適用
        tmpResultList = this.filterResultTable(tmpResultList, setting.itemId, setting.dataType, setting.filterCondition2, setting.filterValue2);
      }

      // フィルタの適用結果を検索結果一覧に反映
      this.resultList = tmpResultList;
      // 検索結果一覧を並び替え
      this.sortResultTable(this.defaultSortField, this.defaultSortDirection);

      // フィルタ適用後の検索結果一覧から選択行のリストを再作成(差し替えたresultListから再抽出が必要)
      // 1. 選択行のリストから患者IDを抽出
      let checkedPatientIdList = this.checkedRows.map(record => record.patientId);
      // 2. フィルタ適用後の検索結果一覧から選択行を抽出
      let checkedRowsInResultList = this.resultList.filter(record => checkedPatientIdList.includes(record.patientId));
      // 3. 2.の抽出結果から患者IDを抽出
      let filteredPatientIdList = checkedRowsInResultList.map(record => record.patientId);
      // 4. 選択行のリストから2.で抽出されなかった選択行を抽出
      let otherCheckedRows = this.checkedRows.filter(record => !filteredPatientIdList.includes(record.patientId));
      // 5. 2.の抽出結果と4.の抽出結果を連結したリストを選択行のリストとして設定
      this.checkedRows = checkedRowsInResultList.concat(otherCheckedRows);

      // 検索結果一覧の設定を調整
      this.$nextTick(this.setResultTableSetting);
    },
    setResultTableSetting: function() {
      // 表示するカラムを変更
      this.setColumns();

      // 検索結果一覧のテーブルを取得
      let resultTable = document.getElementById("pDashboardMainResultTable");

      // 検索結果一覧を表示している場合のみ処理する
      if (resultTable) {
        let tableWrapper = resultTable.getElementsByClassName("table-wrapper")[0];
        let table = resultTable.getElementsByTagName("table")[0];

        // 初期値は行選択チェックボックスの横幅
        let tableWidth = 33;
        for (let setting of this.displayTemplate.settingList) {
          // 検索結果一覧のテーブル幅を算出
          tableWidth += setting.displayFlag ? setting.width : 0;
        }

        // 検索結果一覧のテーブル幅を設定
        table.style.width = tableWidth + "px";

        // 検索結果一覧の横スクロールとフィルタの横スクロール(非表示)を同期
        tableWrapper.removeEventListener("scroll", this.onScroll);
        tableWrapper.addEventListener("scroll", this.onScroll);
      }
    },
    filterResultTable: function(resultList, itemId, dataType, filterCondition, filterValue) {
      // フィルタ値が未設定の場合はそのまま返却(VueTimePickerの時間は一度入力するとNULLに戻らない)
      if (!filterValue || (this.isTimeType(dataType) && !filterValue.H && !filterValue.m)) {
        return resultList;
      }

      let filteredResultList;
      if (this.isNumericType(dataType)) {
        // データ型が数値の場合
        // フィルタ値を数値に変換
        let filterNumber = Number(filterValue);

        // データ型が数値の場合
        switch (filterCondition) {
          // 等しい
          case this.filterCondition.equal:
            filteredResultList
              = resultList.filter(record => record[itemId] != null ? Number(record[itemId]) == filterNumber : false);
            break;
          // 以上
          case this.filterCondition.greaterEqual:
            filteredResultList
              = resultList.filter(record => record[itemId] != null ? Number(record[itemId]) >= filterNumber : false);
            break;
          // 以下
          case this.filterCondition.lessEqual:
            filteredResultList
              = resultList.filter(record => record[itemId] != null ? Number(record[itemId]) <= filterNumber : false);
            break;
          // より大きい
          case this.filterCondition.greater:
            filteredResultList
              = resultList.filter(record => record[itemId] != null ? Number(record[itemId]) > filterNumber : false);
            break;
          // より小さい
          case this.filterCondition.less:
            filteredResultList
              = resultList.filter(record => record[itemId] != null ? Number(record[itemId]) < filterNumber : false);
            break;
          default:
            filteredResultList = resultList;
            break;
        }
      } else if (this.isTimeType(dataType)) {
        // データ型が時間の場合
        // フィルタ値(H時間m分)を分換算
        let minutes = this.getMinutesByObject(filterValue);

        switch (filterCondition) {
          // 等しい
          case this.filterCondition.equal:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.getMinutesByString(record[itemId]) == minutes : false);
            break;
          // 以上
          case this.filterCondition.greaterEqual:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.getMinutesByString(record[itemId]) >= minutes : false);
            break;
          // 以下
          case this.filterCondition.lessEqual:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.getMinutesByString(record[itemId]) <= minutes : false);
            break;
          // より大きい
          case this.filterCondition.greater:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.getMinutesByString(record[itemId]) > minutes : false);
            break;
          // より小さい
          case this.filterCondition.less:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.getMinutesByString(record[itemId]) < minutes : false);
            break;
          default:
            filteredResultList = resultList;
            break;
        }
      } else {
        // フィルタ値のスペースを除去
        filterValue = this.removeSpaces(filterValue);

        // データ型が文字列または日付の場合
        switch (filterCondition) {
          // 含む
          case this.filterCondition.include:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.removeSpaces(record[itemId]).includes(filterValue) : false);
            break;
          // 等しい
          case this.filterCondition.equal:
            filteredResultList
              = resultList.filter(record => record[itemId] ? this.removeSpaces(record[itemId]) == filterValue : false);
            break;
          // 以降のフィルタ条件は日付の場合のみ
          // 以上
          case this.filterCondition.greaterEqual:
            filteredResultList
              = resultList.filter(record => record[itemId] ? record[itemId] >= filterValue : false);
            break;
          // 以下
          case this.filterCondition.lessEqual:
            filteredResultList
              = resultList.filter(record => record[itemId] ? record[itemId] <= filterValue : false);
            break;
          // より大きい
          case this.filterCondition.greater:
            filteredResultList
              = resultList.filter(record => record[itemId] ? record[itemId] > filterValue : false);
            break;
          // より小さい
          case this.filterCondition.less:
            filteredResultList
              = resultList.filter(record => record[itemId] ? record[itemId] < filterValue : false);
            break;
          default:
            filteredResultList = resultList;
            break;
        }
      }

      return filteredResultList;
    },
    removeSpaces: function(value) {
      return value.replace(/( |　)/g, "");
    },
    clearFilter: function() {
      // フィルタをクリア
      for (let setting of this.displayTemplate.settingList) {
        let filterCondition = this.getDefaultFilterCondition(setting.dataType);

        setting.filterValue1 = null;
        setting.filterCondition1 = filterCondition;
        setting.filterValue2 = null;
        setting.filterCondition2 = filterCondition;
      }

      // フィルタを適用
      this.filterResultTableAll();
    },
    getDefaultFilterCondition: function(dataType) {
      // データ型が文字列の場合は「含む」、それ以外の場合は「等しい」
      return this.isStringType(dataType) ? this.filterCondition.include : this.filterCondition.equal;
    },
    showTextTranscription: function() {
      // 転記テンプレートの選択有無を確認
      if (this.textTemplateId) {
        // 選択されている場合はテキスト転記画面を表示
        this.transcribingTextModalActive = true;
      } else {
        // 選択されていない場合は警告メッセージを表示
        this.showErrorMessage("転記テンプレートを選択してください。");
      }
    },
    closeModal: function(){
      // 患者管理表示フラグ
      this.patientManagementModalActive = false;
      // 環境設定表示フラグ
      this.systemSettingModalActive = false;
      // 表示テンプレート登録表示フラグ
      this.displayTemplateRegisterModalActive = false;
      // ファイル出力設定表示フラグ
      this.fileOutputSettingModalActive = false;
      // テキスト転記表示フラグ
      this.transcribingTextModalActive = false;
    },
    backSystemSetting: function(settingList, displayTemplateList, textTemplateList) {
      // 表示テンプレートリスト
      this.displayTemplateList = displayTemplateList;
      // 転記テンプレートリスト
      this.textTemplateList = textTemplateList;

      // 設定情報の明細表示順を更新する
      for (let setting of settingList) {
        setting.detailDisplayOrder = setting.itemId == this.defaultSortField ? this.defaultSortDirection : null;
      }

      // 表示項目保持リストから表示テンプレートリストの表示項目設定情報を反映する
      let newDisplayItemKeepList = [];
      for (let displayTemplate of this.displayTemplateList) {
        let keepItem = this.displayItemKeepList.find(keepItems => keepItems.id == displayTemplate.id);
        if (keepItem) {
          displayTemplate.settingList = keepItem.settingList;
          // 今回変更した表示テンプレートの設定情報を表示項目保持リストにも反映
          if (keepItem.id == this.displayTemplateId) {
            keepItem.settingList = settingList;
          }
          newDisplayItemKeepList.push(displayTemplate);
        }
      }
      // 項目保持リストから削除された表示テンプレートを削除する
      this.displayItemKeepList = newDisplayItemKeepList;

      // 選択中の表示テンプレート(選択中の表示テンプレートは環境設定で削除不可)
      this.displayTemplate = this.displayTemplateList.find(template => {
        return template.id == this.displayTemplateId;
      });
      // 選択中の表示テンプレートの設定情報リスト
      this.displayTemplate.settingList = settingList;

      // フィルタを適用
      this.filterResultTableAll();

      // スクロールの位置をリセット
      this.resetScrollPosition();

      // 選択中だった転記テンプレートを取得
      let textTemplate = this.textTemplateList.find(template => {
        return template.id == this.textTemplateId;
      });

      // 選択中だった転記テンプレートがない場合
      if (!textTemplate) {
        // 既定の転記テンプレートを選択
        let defaultTemplate = this.textTemplateList.find(template => template.defaultFlag);
        this.textTemplateId = defaultTemplate ? defaultTemplate.id : null;
      }
    },
    backDisplayTemplateRegister: function(displayTemplateList, displayTemplateId) {
      // 表示テンプレートリスト
      this.displayTemplateList = displayTemplateList;
      // 選択中の表示テンプレートID
      this.displayTemplateId = displayTemplateId;
      // 選択中の表示テンプレート
      this.displayTemplate = this.displayTemplateList.find(template => {
        return template.id == this.displayTemplateId;
      });

      // 項目保持リストに選択中の表示テンプレートが存在するか判別する
      let updateTargetItem = this.displayItemKeepList.find(keepItem => keepItem.id == this.displayTemplateId);
      // 項目保持リストに選択中の表示テンプレートが存在する(上書き保存)
      if (updateTargetItem) {
        // 項目保持リストの表示テンプレートを更新する
        let updatedKeepList = this.displayItemKeepList.map(keepItem => {
          return keepItem.id == updateTargetItem.id ? this.displayTemplate : keepItem;
        })
        this.displayItemKeepList = updatedKeepList;
      // 項目保持リストに選択中の表示テンプレートが存在しない(新規登録)
      } else {
        // 項目保持リストに新規表示テンプレートを追加する
        this.displayItemKeepList.push(this.displayTemplate);
      }
    },
    downloadExcel: async function(){
      let _this = this;
      await this.apiCall(
        function(client) {
          console.log(client.apis.externalPDashboard.downloadExcelPOST.toString());
          return client.apis.externalPDashboard.downloadExcelPOST(
            { body:{} },
          );

        },
        function(result) {
          if (result && result.status == 200) {
            console.log(result.data instanceof ArrayBuffer);

            console.log(result);
            console.log(result.headers);
            console.log(result.obj);


            // ダウンロードするファイル情報を取得
            let fileInfo = result.headers["content-disposition"].split("=")[1];
            // ファイル情報からファイル名を取得
            let fileName = fileInfo.slice(fileInfo.lastIndexOf("\'") + 1);
            const blob = new Blob([result.data], {
              type: "application/vnd.ms-excel.sheet.macroEnabled.12"
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(fileName);
            // メッセージを表示する前にダウンロードを開始
            link.click();
            _this.showMessage("ファイルの作成が完了しました。");
          } else {
            // エラーメッセージを表示
            _this.showErrorMessage(UNEXPECTED_ERROR);
          }
        },
        function(result){
          // エラーメッセージを表示
          _this.showErrorMessage(result);
        }
      );
    },
    goCo: function() {
      // 別タブでCOのログイン画面を表示(ログイン済みの場合はCOのホーム画面)
      window.open("https://" + this.hostName + "/#/login", "_blank");
    },
    goHome: function() {
      if (this.isInternalUser) {
        // 内部ユーザの場合
        this.$router.push({ path: "/philips/home" });
      } else {
        // 外部ユーザの場合
        this.$router.push({ path: "/guest/home" });
      }
    },
    isStringType: function(dataType) {
      return dataType == "string";
    },
    isNumericType: function(dataType) {
      return dataType == "integer" || dataType == "decimal";
    },
    isTimeType: function(dataType) {
      return dataType == "time";
    },
    getMinutesByObject: function(time) {
      // オブジェクトの「{ H: "X", m: "X" }」を分換算
      let minutes = 0;

      // 時間を分に換算して加算
      if (time.H) {
        minutes += Number(time.H) * 60;
      }

      // 分を加算
      if (time.m) {
        minutes += Number(time.m);
      }

      return minutes;
    },
    getMinutesByString: function(time) {
      // 文字列の「X時間X分」を分換算
      let minutes = 0;

      // 時間を分に換算して加算
      let hoursIndex = time.indexOf("時間");
      if (0 < hoursIndex) {
        let hours = Number(time.substr(0, hoursIndex));
        minutes += hours * 60;
        time = time.substr(hoursIndex + 2);
      }

      // 分を加算
      let minutesIndex = time.indexOf("分");
      if (0 < minutesIndex) {
        minutes += Number(time.substr(0, minutesIndex));
      }

      return minutes;
    },
    setAnchor: function() {
      // フィルタ条件ドロップダウンの表示位置とするアンカーを取得
      let anchor = document.getElementById("anchorFilter");
      // フォーカスされている要素から画面上の表示位置を取得
      let element = document.activeElement;
      let rect = element.getBoundingClientRect();

      // アンカーを移動することでドロップダウンの表示位置を調整
      anchor.style.left = rect.left + "px";
      anchor.style.top = rect.top + "px";
    },
    reDisplayColumns() {
      // すべて選択ボタン押下後、テキスト転記画面を開くとヘッダが消えるため表示するカラムを再設定(b-tableのバグ対応)
      this.setColumns;
      // すべて選択ボタン押下後、テキスト転記画面を開くとソートが乱れるためソート順を再設定(b-tableのバグ対応)
      this.sortResultTable(this.defaultSortField, this.defaultSortDirection);
    }
  },
  components: {
    "vue-timepicker": VueTimepicker,
    // 患者管理モーダル画面
    PDashboardPatientManagementModal: PDashboardPatientManagementModal,
    // 帳票出力画面
    PDashboardExcelDownload: PDashboardExcelDownload,
    // 環境設定モーダル画面
    PDashboardSystemSettingModal: PDashboardSystemSettingModal,
    // テキスト転記モーダル画面
    PDashboardTranscribingTextModal: PDashboardTranscribingTextModal,
    // ファイル出力設定画面
    PDashboardFileOutputSettingModal: PDashboardFileOutputSettingModal,
    // 表示テンプレート登録画面
    PDashboardDisplayTemplateRegisterModal: PDashboardDisplayTemplateRegisterModal
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.labelTitle-area {
  float: right;
}
.operation-area {
  height: 50px;
  text-align: left;
  background-color: rgb(231, 241, 246);
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
}
.header-button-aria {
  margin-top: 5px;
  text-align: right;
}
.condition-input-aria {
  margin-top: -30px;
  margin-left: 40px;
  text-align: left;
}
.result-sub-area {
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 3px;
  display: flex;
  flex-flow: column;
}
.result-table-area {
  margin-right: 5px;
  margin-bottom: -15px;
  position: relative;
}
.result-table-area:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 88%;
  background: white;
  z-index: 3;
}
.template-area {
  margin-top: 10px;
  float: right;
}
.condition-date-input {
  width: 150px;
  height: 25px;
}
.display-button, .save-button {
  width: 60px;
  height: 25px;
}
.header-button {
  width: 130px;
  margin-left: 5px;
}
.co-button {
  min-height: 36px;
  font-size: 60%;
  text-align: left;
}
.result-count {
  margin-top: 2px;
}
.result-count-title {
  margin-top: 10px;
  margin-left: 20px;
  float:left;
}
.template-select {
  width: 220px;
  margin-top: -5px;
}
.save-button {
  margin-top: -2px;
  margin-right: 20px;
}
.operation-aria-tooltip {
  margin-top: 6px;
  margin-left: 10px;
}
.operation-aria-button {
  width: 36px;
  padding: 6px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
}
.operation-aria-button:disabled {
  background: lightgray;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6);
}
.button-img {
  width: 22px;
  height: 22px;
  margin-top: 6px;
}
.filter-first-td {
  min-width: 33px;
  background-color: white;
}
.filter-value-input {
  height: 20px;
  font-size: 80%;
}
.filter-value-input::placeholder {
  text-align: left;
}
.filter-condition-button {
  width: 20px;
  height: 20px;
  padding: 0px;
  text-align: left;
  color: dimgray;
  background-color: transparent;
  border: none;
}
.anchor-filter {
  position: fixed;
  anchor-name: --anchor-filter;
}
.pdashboard-result-table {
  position: relative;
}
.pdashboard-result-table:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: white;
  z-index: 2;
}
.pdashboard-result-table tbody td {
  padding-right: 20px;
}
.pdashboard-filter-table {
  overflow-x: hidden;
  overflow-y: scroll;
  display: grid;
  margin-top: 4px;
}
.pdashboard-filter-table tr td {
  display: inline-flex;
  padding-top: 2px;
}
.pdashboard-filter-table tr td:nth-child(1),
.pdashboard-filter-table tr td:nth-child(2),
.pdashboard-filter-table tr td:nth-child(3) {
  position: -webkit-sticky;
  position: sticky;
  z-index: 4;
  background: white;
}
.pdashboard-filter-table tr td:nth-child(1) {
  left: 0px;
}
.pdashboard-filter-table tr td:nth-child(2) {
  left: 33px;
}
.pdashboard-filter-table tr td:nth-child(3) {
  left: 153px;
}
input[type=number] {
  text-align: right;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
<style lang="scss">
  #pDashboardMainResultTable .table th .th-wrap
{
  // 数値項目でもヘッダは左寄せ(row-reverseを解除)
  flex-direction: row;
}
#pDashboardMainResultTable tr.unuse td {
  // 対象期間内に装置を未使用の患者(行)は薄灰色
  background: lightgray !important;
}
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(2),
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(3)
{
  // 対象期間内に装置を使用済の患者(行)は薄黄色
  background-color: lightyellow;
}
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th,
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(1)
{
  // 行選択は白色(明細が0件の場合にヘッダの下が薄黄色になるため)
  background-color: white;
}
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(1),
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(2),
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(3)
{
  // 縦横スクロール時に明細を固定
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
}
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th
{
  // 縦スクロール時にヘッダを固定
  position: -webkit-sticky;
  position: sticky;
  top: 1px;
  z-index: 2;
}
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th:nth-child(1),
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th:nth-child(2),
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th:nth-child(3)
{
  // 横スクロール時にヘッダを固定
  z-index: 3;
}
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th:nth-child(1),
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(1)
{
  // 横スクロール時に行選択の横位置を固定
  left: 2px;
}
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th:nth-child(2),
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(2) {
  // 横スクロール時に診察券IDの横位置を固定
  left: 31px;
}
#pDashboardMainResultTable .table-wrapper thead tr:nth-child(1) th:nth-child(3),
#pDashboardMainResultTable .table-wrapper tbody td:nth-child(3) {
  // 横スクロール時に患者氏名の横位置を固定
  left: 151px;
}
#pDashboardMainFilterCondition .dropdown-content {
  bottom: calc(anchor(--anchor-filter bottom) + 5px);
  left: anchor(--anchor-filter left);
  position: fixed;
  padding: 3px;
  background-color: lightyellow;
}
#pDashboardMainFilterTable input.filtered-input,
#pDashboardMainFilterTable span.filtered-input input {
  background-color: lightyellow;
  border: 1px solid #767676;
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardMain.vue